import React, { useEffect, useRef, useState } from 'react';
import { Form, Container, Button, Card, Col, Row } from 'react-bootstrap';
import QuantityMakeModal from './QuantityMakeModal';
import SolarArray from './SolarArray';
import {
  EQ_TYP,
  optionMapper,
  optionValueMapper,
  programList,
} from '../constant';
import { StyledButton } from '../../StyledComponets';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchEquipmentData,
  getEquipmentMfrs,
} from '../../app/equipment/equipmentSlice';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  CP_KEY,
  initialValues,
  validationSchema,
  onDeleteEquipment,
  onDeleteProduct,
  onUpdateEquipment,
  onUpdateProduct,
  getModalListforDropDown,
  calculateMaxCPwr,
  calcTotalPC,
} from './helpers';

export default function EnrollmentForm(props) {
  const { program,pageType } = props;
  const dispatch = useDispatch();
  const isView = pageType ==="view"
  const [inverterList, setInverterList] = useState([]);
  const [iesList, setIESList] = useState([]);
  const [syncIndList, setSyncIndList] = useState([]);
  const [updateId, setUpdateId] = useState(null);
  const manufacturesObject = useSelector(getEquipmentMfrs);
  const qtyFormRef = useRef();

  const {
    register,
    watch,
    handleSubmit,
    trigger,
    setValue,
    getValues,
    reset,
    formState: { errors, isValid, isValidating },
  } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    resolver: yupResolver(validationSchema),
    defaultValues: initialValues,
  });

  const checkInverterSubValid = () => {
    const validInverters = inverterList.filter((x) => x?.isValid);
    const addedSubObjects = validInverters?.filter(
      (x) => x?.battery.length > 0 || x?.solar.length > 0
    );
    if (
      validInverters?.length === inverterList?.length &&
      validInverters.length === addedSubObjects.length
    ) {
      const filterSolarObjects = addedSubObjects.filter((x) => x?.solar.length);
      const validSolarObjects = filterSolarObjects.filter(
        (i) => i.solar.filter((x) => x?.isValid).length === i.solar.length
      );
      const filterBatteryObjects = addedSubObjects.filter(
        (x) => x?.battery.length
      );
      const validBatteryObjects = filterBatteryObjects.filter(
        (i) => i.battery.filter((x) => x?.isValid).length === i.battery.length
      );
      return (
        filterSolarObjects.length === validSolarObjects.length &&
        filterBatteryObjects.length === validBatteryObjects.length
      );
    }
    return false;
  };

  const checkIESSubValid = () => {
    const validIes = iesList.filter((x) => x?.isValid);
    const addedSubObjects = validIes?.filter((x) => x?.solar.length > 0);
    if (validIes?.length === iesList?.length) {
      const filterSolarObjects = addedSubObjects.filter((x) => x?.solar.length);
      if (filterSolarObjects.length) {
        const validSolarObjects = filterSolarObjects.filter(
          (i) => i.solar.filter((x) => x?.isValid).length === i.solar.length
        );
        return filterSolarObjects.length === validSolarObjects.length;
      }
      return true;
    }
    return false;
  };

  const checkAtleastOneEquipment = () => {
    return inverterList.length || iesList.length;
  };

  const checkFormErrors = () => {
    trigger();
    const qtyFormValid = qtyFormRef.current?.triggerQtyForm();
    return isValid && qtyFormValid;
  };

  const isValidProgram =
    isValid &&
    checkAtleastOneEquipment() &&
    checkInverterSubValid() &&
    checkIESSubValid();
  const onSaveProgram = () => {
    checkFormErrors();
    props.updateProgram(props.pgmId, { isValid: isValidProgram });
  };

  useEffect(() => {
    const data = { inverters: inverterList, integratedEnergySystems: iesList };
    props.updateProgram(props.pgmId, {
      [CP_KEY.PGM_TYPE]: getValues(CP_KEY.PGM_TYPE),
      isValid: isValidProgram,
      data: data,
    });
  }, [isValidProgram, inverterList, iesList, isValidating]);

  useEffect(() => {
    setValue(CP_KEY.PGM_TYPE, program?.[CP_KEY.PGM_TYPE]);
    if (program?.data?.inverters?.length) {
      setInverterList(program.data?.inverters);
    }
    if (program?.data?.integratedEnergySystems?.length) {
      setIESList(program.data?.integratedEnergySystems);
    }
  }, [props.formData]);

  useEffect(() => {
    if (!manufacturesObject) {
      dispatch(fetchEquipmentData());
    }
  }, []);

  const onAddEquipment = (equipList, setEquipList, deviceNmList) => {
    const uniqueID = () => Math.floor(Math.random() * Date.now());
    const deviceInitial = deviceNmList?.reduce(
      (acc, curr) => ((acc[curr] = []), acc),
      {}
    );
    const id = uniqueID();
    setEquipList([...equipList, { eqId: id, ...deviceInitial, mdl: [] }]);
  };

  const onAddProduct = (eqId, equipList, setEquipList, deviceNm) => {
    const uniqueID = () => Math.floor(Math.random() * Date.now());
    const eqItem = equipList.find((x) => x.eqId === eqId);
    const eqIndex = equipList.indexOf(eqItem);

    if (eqIndex >= 0) {
      const id = uniqueID();
      const updateItem = {
        ...eqItem,
        [deviceNm]: [...eqItem[deviceNm], { pId: id, mdl: [] }],
      };
      const newState = [...equipList];
      newState[eqIndex] = updateItem;
      //newState.splice(equipList.indexOf(eqItem), 1, updateItem);
      setEquipList(newState);
    }
  };

  const solarSection = (equipId, productId, eqList, setEqlist, item) => {
    const onUpdateModals = (mdlList) =>
      onUpdateProduct(equipId, updateId?.pId, eqList, setEqlist, 'solar', {
        mdl: mdlList,
      });
    const onDataUpdate = (obj, eqId, pId) =>
      onUpdateProduct(eqId, pId, eqList, setEqlist, 'solar', obj);
    const modalList = getModalListforDropDown(
      eqList,
      equipId,
      productId,
      'solar'
    );

    return (
      <Card style={{ margin: '4px', padding: '4px' }} key={productId}>
        <span>
          <Form.Text size="sm" id="ptc-rating">
            {' '}
            Solar Array
          </Form.Text>
          {!isView && (
            <Button
              variant="link"
              size="sm"
              onClick={() =>
                onDeleteProduct(equipId, productId, eqList, setEqlist, 'solar')
              }
            >
              Delete Solar
            </Button>
          )}
        </span>
        <SolarArray
          eqId={equipId}
          pId={productId}
          item={item}
          pageType={pageType}
          onDataUpdate={onDataUpdate}
          makeList={manufacturesObject?.solar}
          modalList={modalList}
          onUpdateModals={onUpdateModals}
          setUpdateId={setUpdateId}
          formData={props.formData}
        />
      </Card>
    );
  };

  const quantitySection = (
    name,
    eqList,
    setEqList,
    equipId,
    productId,
    deviceNm,
    makeList,
    item
  ) => {
    const onDelete = () => onDeleteEquipment(equipId, eqList, setEqList);
    const onDataUpdate = (obj, eqId) =>
      onUpdateEquipment(eqId, eqList, setEqList, obj);
    const onUpdateModals = (mdlList) =>
      !updateId?.pId &&
      onUpdateEquipment(updateId?.eqId, eqList, setEqList, {
        mdl: mdlList,
        battery: [],
        solar: [],
      });
    const modalList = getModalListforDropDown(
      eqList,
      equipId,
      productId,
      deviceNm
    );

    return (
      <QuantityMakeModal
        ref={qtyFormRef}
        key={`${equipId}${productId}`}
        item={item}
        pageType={pageType}
        onDataUpdate={onDataUpdate}
        onDelete={onDelete}
        eqId={equipId}
        pId={productId}
        makeList={makeList}
        modalList={modalList}
        name={name}
        onUpdateModals={onUpdateModals}
        setUpdateId={setUpdateId}
        formData={props.formData}
      />
    );
  };

  const quantityProductSection = (
    name,
    eqList,
    setEqList,
    equipId,
    productId,
    deviceNm,
    makeList,
    item
  ) => {
    const onDelete = () =>
      onDeleteProduct(equipId, productId, eqList, setEqList, deviceNm);
    const onDataUpdate = (obj, eqId, pId) =>
      onUpdateProduct(eqId, pId, eqList, setEqList, deviceNm, obj);
    const onUpdateModals = (mdlList) =>
      onUpdateProduct(
        updateId?.eqId,
        updateId?.pId,
        eqList,
        setEqList,
        deviceNm,
        { mdl: mdlList }
      );

    const modalList = getModalListforDropDown(
      eqList,
      equipId,
      productId,
      deviceNm
    );

    return (
      <QuantityMakeModal
        ref={qtyFormRef}
        key={`${equipId}${productId}`}
        item={item}
        pageType={pageType}
        onDataUpdate={onDataUpdate}
        onDelete={onDelete}
        eqId={equipId}
        pId={productId}
        makeList={makeList}
        modalList={modalList}
        name={name}
        onUpdateModals={onUpdateModals}
        setUpdateId={setUpdateId}
        formData={props.formData}
      />
    );
  };

  const checkSolarBattery = (item, btn) => {
    const modal = item?.mdl?.find((ml) => ml.MDL_NM === item.smdl);
    if (btn == 'battery') {
      return (
        modal?.INVERTERTYPE == EQ_TYP.hybrid_inverter ||
        modal?.INVERTERTYPE == EQ_TYP.bt_inverter
      );
    } else if (btn == 'solar') {
      return (
        modal?.INVERTERTYPE == EQ_TYP.hybrid_inverter ||
        modal?.INVERTERTYPE == EQ_TYP.pv_inverter
      );
    }
  };

  const checkSolarIES = (item) => {
    const modal = item?.mdl?.find((ml) => ml.MDL_NM === item.smdl);
    return modal?.PV_DC_INP_CAPABILITY?.trim() === 'Y';
  };

  const inverterSection = () => {
    return inverterList?.map((item, index) => (
      <Container key={item.eqId} style={{ margin: '4px', padding: '4px' }}>
        <Row>
          <div>
            <b>Inverter-{index + 1} </b>
            <Form.Text size="sm">
              {calcTotalPC(item, 'MAX_CONT_PWR_UPF_KW')
                ? `  (Total Physical Capacity(kW):${calcTotalPC(
                    item,
                    'MAX_CONT_PWR_UPF_KW'
                  ).toFixed(3)})`
                : ''}
            </Form.Text>
          </div>
          {quantitySection(
            EQ_TYP.pv_inverter,
            inverterList,
            setInverterList,
            item.eqId,
            null,
            null,
            manufacturesObject?.inverter,
            item
          )}
          <Form.Text
            size="sm"
            style={{ marginTop: '-10px', marginBottom: '10px' }}
          >
            {item?.modelData?.MAX_CONT_PWR_UPF_KW &&
              item?.data?.[CP_KEY.QTY] &&
              `Maximum Continues Power(kW):${calculateMaxCPwr(
                item?.modelData?.MAX_CONT_PWR_UPF_KW,
                item?.data?.[CP_KEY.QTY]
              )}`}{' '}
          </Form.Text>
        </Row>
        {item?.battery?.map((i, btIndex) => (
          <Row key={i.pId} style={{ marginLeft: '25px' }}>
            <span>Battery-{btIndex + 1}</span>
            {quantityProductSection(
              EQ_TYP.battery,
              inverterList,
              setInverterList,
              item.eqId,
              i.pId,
              'battery',
              manufacturesObject?.battery,
              i
            )}
            <Form.Text size="sm" style={{ marginTop: '-10px' }}>
              {i?.modelData?.MAX_CONT_DISC_RATE_KW &&
                i?.data?.[CP_KEY.QTY] &&
                `Maximum Continues Discharge Rate(kW):${calculateMaxCPwr(
                  i?.modelData?.MAX_CONT_DISC_RATE_KW,
                  i?.data?.[CP_KEY.QTY]
                )}`}{' '}
            </Form.Text>
            <Form.Text size="sm" style={{ marginBottom: '10px' }}>
              {i?.modelData?.NMP_CAPACITY_KWH &&
                i?.data?.[CP_KEY.QTY] &&
                `Nameplate Energy Capacity(kWh):${calculateMaxCPwr(
                  i?.modelData?.NMP_CAPACITY_KWH,
                  i?.data?.[CP_KEY.QTY]
                )}`}{' '}
            </Form.Text>
          </Row>
        ))}

        {(checkSolarBattery(item, 'battery') && !isView) && (
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="sm"
            onClick={() =>
              onAddProduct(item.eqId, inverterList, setInverterList, 'battery')
            }
          >
            Add Battery
          </StyledButton>
        )}
        {item?.solar?.map((i) =>
          solarSection(item.eqId, i.pId, inverterList, setInverterList, i)
        )}
        {(checkSolarBattery(item, 'solar') && !isView) && (
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="sm"
            onClick={() =>
              onAddProduct(item.eqId, inverterList, setInverterList, 'solar')
            }
          >
            Add Solar
          </StyledButton>
        )}
        {item?.isValid &&
          item?.battery.length === 0 &&
          item?.solar.length === 0 && (
            <div style={{ color: '#DC3545', fontSize: '14px' }}>
              Add atleast one
            </div>
          )}
        {index !== inverterList?.length - 1 && <hr />}
      </Container>
    ));
  };

  const iesSection = () => {
    return iesList?.map((item, index) => (
      <Container style={{ margin: '4px', padding: '4px' }} key={item.eqId}>
        <Row>
          <div>
            <b>Integrated Energy storage-{index + 1} </b>
            <Form.Text size="sm">
              {calcTotalPC(item, 'MAX_CONT_DISC_RATE_KW', true)
                ? ` (Total Physical Capacity(kW):${calcTotalPC(
                    item,
                    'MAX_CONT_DISC_RATE_KW',
                    true
                  ).toFixed(3)})`
                : ''}
            </Form.Text>
          </div>
          {quantitySection(
            EQ_TYP.ess,
            iesList,
            setIESList,
            item.eqId,
            null,
            null,
            manufacturesObject?.ess,
            item
          )}
          <Form.Text size="sm" style={{ marginTop: '-10px' }}>
            {item?.modelData?.MAX_CONT_DISC_RATE_KW &&
              item?.data?.[CP_KEY.QTY] &&
              `Maximum Continues Discharge Rate(kW):${calculateMaxCPwr(
                item?.modelData?.MAX_CONT_DISC_RATE_KW,
                item?.data?.[CP_KEY.QTY]
              )}`}{' '}
          </Form.Text>
          <Form.Text size="sm" style={{ marginBottom: '10px' }}>
            {item?.modelData?.NMP_CAPACITY_KWH &&
              item?.data?.[CP_KEY.QTY] &&
              `Nameplate Energy Capacity(kWh):${calculateMaxCPwr(
                item?.modelData?.NMP_CAPACITY_KWH,
                item?.data?.[CP_KEY.QTY]
              )}`}{' '}
          </Form.Text>
        </Row>
        {item?.solar?.map((i) =>
          solarSection(item.eqId, i.pId, iesList, setIESList, i)
        )}
        {(checkSolarIES(item) && !isView) && (
          <StyledButton
            btnType="secondary"
            variant="dark"
            size="sm"
            onClick={() =>
              onAddProduct(item.eqId, iesList, setIESList, 'solar')
            }
          >
            Add Solar
          </StyledButton>
        )}
        {index !== iesList?.length - 1 && <hr />}
      </Container>
    ));
  };

  const syncIndSection = () => {
    return syncIndList?.map((item, index) => (
      <Container style={{ margin: '4px', padding: '4px' }} key={item.eqId}>
        {quantitySection(
          '',
          syncIndList,
          setSyncIndList,
          item.eqId,
          null,
          null
        )}
        {item.battery.length > 0 && <span>Battery</span>}
        {item.battery?.map((i) => (
          <Row key={i.pId}>
            {quantityProductSection(
              EQ_TYP.battery,
              syncIndList,
              setSyncIndList,
              item.eqId,
              i.pId,
              'battery',
              i
            )}
          </Row>
        ))}
        <StyledButton
          btnType="secondary"
          variant="dark"
          size="sm"
          onClick={() =>
            onAddProduct(item.eqId, syncIndList, setSyncIndList, 'battery')
          }
        >
          Add Battery
        </StyledButton>
        {index !== syncIndList.length - 1 && <hr />}
      </Container>
    ));
  };

  const renderError = (key) =>
    errors?.[key]?.message && (
      <Form.Control.Feedback type="invalid">
        {errors?.[key]?.message}
      </Form.Control.Feedback>
    );
  return (
    <Form noValidate onSubmit={handleSubmit(() => {})}>
      <Form.Group>
        <Form.Text size="sm" style={{ margin: '2px' }}>
          Program type
        </Form.Text>
        <Form.Select
          size="sm"
          aria-label="pgmType"
          {...register(CP_KEY.PGM_TYPE)}
          isInvalid={errors[CP_KEY.PGM_TYPE]}
          disabled={isView}
        >
          <option value="">Please select</option>
          {optionValueMapper(programList)}
        </Form.Select>
        {renderError(CP_KEY.PGM_TYPE)}
      </Form.Group>
      {!isView && (
        <>
          <Form.Text size="sm" style={{ margin: '2px' }}>
            Equipments (click to add*){' '}
          </Form.Text>
          <StyledButton
            btnType="primary"
            variant="dark"
            size="sm"
            onClick={() =>
              onAddEquipment(inverterList, setInverterList, [
                'battery',
                'solar',
              ])
            }
          >
            Add Inverter
          </StyledButton>
          <StyledButton
            btnType="primary"
            variant="dark"
            size="sm"
            onClick={() => onAddEquipment(iesList, setIESList, ['solar'])}
          >
            Add Integrated Battery Storage
          </StyledButton>
        </>
      )}
      {!inverterList.length && !iesList.length && (
        <div style={{ color: '#DC3545', fontSize: '14px' }}>
          Add atleast one equipment
        </div>
      )}

      {/* <StyledButton
              btnType="primary"
              variant="dark"
              size="sm"
              onClick={() =>
                onAddEquipment(syncIndList, setSyncIndList, ['battery'])
              }
            >
              Add Synchronous Induction
            </StyledButton> */}
      <hr />
      {/* INVERTER */}
      {inverterList?.length > 0 && (
        <Card>
          <Card.Header>
            <b>{`Inverter Equipment `}</b> ({inverterList.length} Qty)
          </Card.Header>
          {inverterSection()}
        </Card>
      )}
      <br />
      {/* IES */}
      {iesList?.length > 0 && (
        <Card>
          <Card.Header>
            {' '}
            <b>{`Integrated Energy storage Equipment`}</b> ({iesList.length}{' '}
            Qty)
          </Card.Header>
          {iesSection()}
        </Card>
      )}
      {/* SYNC IND */}
      {syncIndList?.length > 0 && syncIndSection()}
      {!isView && (
        <StyledButton
          btnType=""
          variant="dark"
          onClick={() => onSaveProgram()}
          size="sm"
        >
          Validate
        </StyledButton>
      )}
    </Form>
  );
}
